import React, { useState } from 'react';
import { ChevronDown, Menu, X } from 'lucide-react';
import { Button } from './ui/Button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from './ui/DropdownMenu';
export function Navbar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  return <header className="sticky top-0 z-50 w-full h-[74px] bg-white border-b border-gray-100 shadow-sm flex items-center" data-id="element-145">
      <div className="container mx-auto px-4 md:px-8 flex items-center justify-between w-full" data-id="element-146">
        {/* Logo */}
        <a href="/" className="flex flex-col justify-center" data-id="element-147">
          <img src="https://cdn.magicpatterns.com/uploads/x5LDHU8dDFWY9GtEKeqcMv/logo_ariha.png" alt="ARIH ASM Logo" className="h-10 object-contain" data-id="element-148" />
        </a>

        {/* Desktop Navigation */}
        <nav className="hidden lg:flex items-center space-x-8" data-id="element-149">
          <DropdownMenu data-id="element-150">
            <DropdownMenuTrigger className="flex items-center text-[16px] font-semibold text-arih-nav-text hover:text-arih-blue transition-colors outline-none" data-id="element-151">
              Arih ASM <ChevronDown className="ml-1 h-4 w-4" data-id="element-152" />
            </DropdownMenuTrigger>
            <DropdownMenuContent align="start" className="w-48" data-id="element-153">
              <DropdownMenuItem className="cursor-pointer font-medium" data-id="element-154">
                <a href="/membres-ca" className="w-full" data-id="element-155">
                  Membres CA
                </a>
              </DropdownMenuItem>
              <DropdownMenuItem className="cursor-pointer font-medium" data-id="element-156">
                <a href="/statuts" className="w-full" data-id="element-157">
                  Statuts
                </a>
              </DropdownMenuItem>
              <DropdownMenuItem className="cursor-pointer font-medium" data-id="element-158">
                <a href="/comment-adherer" className="w-full" data-id="element-159">
                  Comment Adhérer
                </a>
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>

          <a href="https://drive.google.com/file/d/1ioRzrd6QiBd9lpO7WHi5FrwFUeApChjX/view" target="_blank" rel="noopener noreferrer" className="text-[16px] font-semibold text-arih-nav-text hover:text-arih-blue transition-colors" data-id="element-160">
            Établissements
          </a>
          <a href="/news" className="text-[16px] font-semibold text-arih-nav-text hover:text-arih-blue transition-colors" data-id="element-161">
            News
          </a>
          <a href="/evenements" className="text-[16px] font-semibold text-arih-nav-text hover:text-arih-blue transition-colors" data-id="element-162">
            Évènements
          </a>
          <a href="/emploi" className="text-[16px] font-semibold text-arih-nav-text hover:text-arih-blue transition-colors" data-id="element-163">
            Emploi
          </a>
          <a href="/formation" className="text-[16px] font-semibold text-arih-nav-text hover:text-arih-blue transition-colors" data-id="element-164">
            Formation
          </a>
          <a href="/contact-us" className="text-[16px] font-semibold text-arih-nav-text hover:text-arih-blue transition-colors" data-id="element-165">
            Contact
          </a>
        </nav>

        {/* Mobile Menu Toggle */}
        <div className="lg:hidden" data-id="element-166">
          <Button variant="ghost" size="icon" aria-label="Menu" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-167">
            {mobileMenuOpen ? <X className="h-6 w-6 text-arih-dark" data-id="element-168" /> : <Menu className="h-6 w-6 text-arih-dark" data-id="element-169" />}
          </Button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && <div className="lg:hidden absolute top-[74px] left-0 right-0 bg-white border-b border-gray-200 shadow-lg" data-id="element-170">
          <nav className="container mx-auto px-4 py-6 flex flex-col space-y-4" data-id="element-171">
            <div className="border-b border-gray-200 pb-4" data-id="element-172">
              <p className="text-[14px] font-bold text-arih-dark mb-3" data-id="element-173">
                Arih ASM
              </p>
              <div className="flex flex-col space-y-3 pl-4" data-id="element-174">
                <a href="/membres-ca" className="text-[16px] font-medium text-arih-nav-text hover:text-arih-blue transition-colors" onClick={() => setMobileMenuOpen(false)} data-id="element-175">
                  Membres CA
                </a>
                <a href="/statuts" className="text-[16px] font-medium text-arih-nav-text hover:text-arih-blue transition-colors" onClick={() => setMobileMenuOpen(false)} data-id="element-176">
                  Statuts
                </a>
                <a href="/comment-adherer" className="text-[16px] font-medium text-arih-nav-text hover:text-arih-blue transition-colors" onClick={() => setMobileMenuOpen(false)} data-id="element-177">
                  Comment Adhérer
                </a>
              </div>
            </div>
            <a href="https://drive.google.com/file/d/1ioRzrd6QiBd9lpO7WHi5FrwFUeApChjX/view" target="_blank" rel="noopener noreferrer" className="text-[16px] font-semibold text-arih-nav-text hover:text-arih-blue transition-colors" onClick={() => setMobileMenuOpen(false)} data-id="element-178">
              Établissements
            </a>
            <a href="/news" className="text-[16px] font-semibold text-arih-nav-text hover:text-arih-blue transition-colors" onClick={() => setMobileMenuOpen(false)} data-id="element-179">
              News
            </a>
            <a href="/evenements" className="text-[16px] font-semibold text-arih-nav-text hover:text-arih-blue transition-colors" onClick={() => setMobileMenuOpen(false)} data-id="element-180">
              Évènements
            </a>
            <a href="/emploi" className="text-[16px] font-semibold text-arih-nav-text hover:text-arih-blue transition-colors" onClick={() => setMobileMenuOpen(false)} data-id="element-181">
              Emploi
            </a>
            <a href="/formation" className="text-[16px] font-semibold text-arih-nav-text hover:text-arih-blue transition-colors" onClick={() => setMobileMenuOpen(false)} data-id="element-182">
              Formation
            </a>
            <a href="/contact-us" className="text-[16px] font-semibold text-arih-nav-text hover:text-arih-blue transition-colors" onClick={() => setMobileMenuOpen(false)} data-id="element-183">
              Contact
            </a>
          </nav>
        </div>}
    </header>;
}